import React from 'react';

export default function InputsShowcase() {
  return (
    <div>
      {/* Initial */}
      <div className="field">
        <div className="state-title">Initial</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" placeholder="" />
        </div>
      </div>

      {/* Active */}
      <div className="field is-active">
        <div className="state-title">Active</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" placeholder="" />
        </div>
      </div>

      {/* Typing */}
      <div className="field is-typing is-active">
        <div className="state-title">Typing</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" defaultValue="Anastasi" />
        </div>
      </div>

      {/* Filled */}
      <div className="field is-filled">
        <div className="state-title">Filled</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" defaultValue="Anastasia" />
        </div>
      </div>

      {/* Disabled */}
      <div className="field is-disabled">
        <div className="state-title">Disabled</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" defaultValue="Anastasia" disabled />
        </div>
      </div>

      {/* Success */}
      <div className="field is-success">
        <div className="state-title">Success</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" defaultValue="Anastasia" />
        </div>
      </div>

      {/* Error */}
      <div className="field is-error">
        <div className="state-title">Error</div>
        <div>
          <div className="label">Your name</div>
          <input className="input" defaultValue="Anastasia" />
        </div>
      </div>
    </div>
  );
}
